import { Routes } from '@angular/router';
import { loginGuard } from './core/guards/login.guard';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'reset-password',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: 'settings',
    canActivateChild: [authGuard],
    loadComponent: () =>
      import('./pages/settings/settings.component').then(
        (m) => m.SettingsComponent
      ),
    loadChildren: () => [
      {
        path: '',
        redirectTo: 'profile',
        pathMatch: 'full',
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/settings/profile/profile.component').then(
            (m) => m.ProfileComponent
          ),
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import(
            './pages/settings/change-password/change-password.component'
          ).then((m) => m.ChangePasswordComponent),
      },
    ],
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [roleGuard],
    loadComponent: () =>
      import('./pages/app-wrapper/app-wrapper.component').then(
        (m) => m.AppWrapperComponent
      ),
    loadChildren: () =>
      import('./pages/app-wrapper/app-wrapper.routes').then(
        (m) => m.appWrapperRoutes
      ),
  },
  {
    path: 'exception',
    children: [
      {
        path: '404',
        loadComponent: () =>
          import('@app-shared/components/exception/not-found.component').then(
            (m) => m.NotFoundComponent
          ),
      },
      {
        path: '500',
        loadComponent: () =>
          import(
            '@app-shared/components/exception/internal-error.component'
          ).then((m) => m.InternalErrorComponent),
      },
      {
        path: '403',
        loadComponent: () =>
          import(
            '@app-shared/components/exception/unauthorized.component'
          ).then((m) => m.UnAuthorizedComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/exception/404',
  },
];
